<script>
import FormCreator from '../UI/Form/FormCreator.vue'
import SimulationHeadband from './SimulationHeadband.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import DocumentList from '../Document/DocumentList.vue'
import MessageList from '../Message/MessageList.vue'
import dynamicFormUtil from '../../Mixins/dynamicFormUtil'
import { globalVariablesMixin } from '../../Mixins/global'
import mixinComponent from '../../Mixins/mixinComponent'
import hasRole from '../../../../Utils/hasRole.ts'
import SimulationLanguage from './SimulationLanguage.vue'

export default {
  components: {
    SimulationLanguage,
    MessageList,
    DocumentList,
    ButtonAll,
    FieldCreator,
    BlockContent,
    SimulationHeadband,
    FormCreator,
  },
  mixins: [dynamicFormUtil, globalVariablesMixin, mixinComponent],

  props: {
    simulationId: { type: Number, required: true },
    simulation: { type: Object, required: true },
    def: { type: Object, required: true },
  },

  data() {
    return {
      simulationFields: [],
      languageFields: [],
      errors: [],
      isDocumentLoaded: true,
      isDemand: false,
      sendingDemand: false,
      sendingRegister: false,
      sendingLanguage: false,
      isDeliveryAt: true,
      formData: null,
      loadFields: false,
    }
  },

  computed: {
    isManuallyStudyable() {
      return (
        ['REFUSED', 'NOT_ACCEPTED', 'TO_BE_COMPLETED'].includes(this.simulation.refinancerStatus) &&
        this.hasRole('ROLE_DETAILLED_STUDY') &&
        this.isTheme(['lbp'])
      )
    },
    createdBy: function () {
      if (this.simulation) {
        if (this.simulation.decision && this.simulation.decision.demand && this.simulation.decision.demand.createdBy) {
          return this.simulation.decision.demand.createdBy.name
        }
        let decisions = this.simulation.decisions
        if (decisions.length > 0) {
          for (const [ind, obj] of Object.entries(decisions)) {
            if (obj.demand && obj.demand.createdBy) {
              return obj.demand.createdBy.name
            }
          }
        }
      }
      return ''
    },
    computeAmount() {
      let amount = 0
      if (this.simulation && this.simulation.finance) {
        amount = parseFloat(this.simulation.finance.simulationAmount)
        if (this.simulation.finance.outstanding) {
          amount += parseFloat(this.simulation.finance.outstanding)
        }
      }

      return this.$n(Number(amount), 'currency')
    },

    isRequestable: function () {
      return (
        ['CLIENT_PROPOSAL', 'CREATED'].includes(this.simulation.status) &&
        this.simulation.refinancerStatus === 'CREATED'
      )
    },
    isAccepted() {
      return ['ACCEPTED', 'ACCEPTED_FORCED', 'CONDITIONAL', 'CLIENT_CONTRACT', 'PREACCEPTED'].includes(
        this.simulation.status,
      )
    },
    showAdditionalInformations() {
      return (
        user.isBusinessMan ||
        user.isAdmin ||
        this.isTheme(['lbp', 'financia', 'itl']) ||
        hasRole('ROLE_SALESMAN_EXT_PREMIUM_SHOW')
      )
    },
  },

  methods: {
    isTheme: (expectedThemes) => expectedThemes.includes(conf.theme_dir),
    updateData(newData) {
      this.formData = newData
    },
    setBuild(bool) {
      this.loadFields = bool
    },
    afterUpload(document) {
      if (
        ['import_decision', 'equipment_import', 'service_import', 'pdf_decision', 'zddf_pdf_decision'].includes(
          document.documentType.internalName,
        )
      ) {
        location.reload()
      }
      this.$refs.documentList.getDocuments()
    },
    documentLoaded(info) {
      this.isDocumentLoaded = true
    },
    sendLanguage() {
      this.$refs.formdemand.methods('patch')
    },
    sendInfo(isFinal) {
      let send = true
      this.$refs.documentList.groupedByCategory.forEach((category) => {
        let missingList = category.missings ?? []
        // A priori documentStudyMandatory n'est activé que sur lbplease
        if (
          !this.isManuallyStudyable &&
          ((config.conf.documentStudyMandatory &&
            isFinal &&
            missingList.length > 0 &&
            !(missingList.length === 1 && missingList[0].document?.documentType?.internalName === 'pdf_decision')) || //exception
            (missingList.length > 0 && missingList.some((e) => e.isBlocking === true)))
        ) {
          send = false
        }
      })

      if (!send) {
        this.$root.jsonStatus = 'error'
        this.$root.jsonStatusText = this.$t('simulation.popin.study.explain')
        $('#modal-waiting-text').modal({ backdrop: 'static', keyboard: false })
      } else {
        if (this.simulation.deliveryAt == null && this.def?.deliveryAt?.options?.required) {
          this.isDeliveryAt = false
          return
        }

        this.isDemand = isFinal
        let specificEndpoint = isFinal ? 'detailled' : null
        this.$refs.formdemand.methods('patch', null, specificEndpoint)
      }
    },
    isLimited() {
      return user.limitRequest && user.limitRequest < this.simulation.finance.amount
    },
    setDatas(json) {
      this.$emit('update-simulation', true)
    },
    setErrors(errors) {
      this.errors = errors
    },
    isSending(bool) {
      if (this.isDemand) {
        this.sendingDemand = bool
      } else {
        this.sendingRegister = bool
      }
    },
  },
}
</script>
<template>
  <div v-if="Object.entries(simulation).length > 0" id="simulation-demand">
    <div>
      <FormCreator
        ref="formdemand"
        src-error="formdemand"
        endpoint="quotations"
        method="patch"
        :id="simulationId"
        :config-def="def"
        :config-object="simulation"
        dynamic
        :params="{ simulationId: simulationId }"
        class-to-add="d-none"
        @form-return="setDatas"
        @form-build="setBuild"
        @is-sending="isSending"
        @error-return="setErrors"
        @update-data="updateData"
      />
      <div class="row">
        <div class="col-md-12">
          <SimulationHeadband :simulation="simulation" :def="def" />
        </div>
      </div>
    </div>

    <SimulationLanguage :simulation="simulation" :def="def" />

    <div class="row">
      <div class="col-xl-6 col-lg-12" v-if="showAdditionalInformations">
        <BlockContent title-t="simulation.comment.title" title-level="4" e2e-block="simulationAdditionalInformations">
          <template v-if="loadFields">
            <FieldCreator
              :form-data="formData"
              name="salesmanAssistant"
              form-ref="formdemand"
              domain="simulation"
              label-top
            />
            <FieldCreator
              :form-data="formData"
              name="activityDescription"
              form-ref="formdemand"
              domain="simulation"
              label-top
              dynamic-label
            />
            <FieldCreator
              :form-data="formData"
              name="motivation"
              form-ref="formdemand"
              domain="simulation"
              label-top
              dynamic-label
            />
            <FieldCreator
              :form-data="formData"
              name="otherInfo"
              form-ref="formdemand"
              domain="simulation"
              label-top
              dynamic-label
            />
            <FieldCreator
              :form-data="formData"
              v-if="hasRole('ROLE_REPORTING_VARIABLE')"
              name="reportingVariables"
              form-ref="formdemand"
              domain="simulation"
              select-multiple
              label-top
            />
          </template>
          <div class="text-center">
            <ButtonAll
              v-if="!user.isReadOnly && simulation.status != 'CANCELED'"
              type="validation"
              label="button.save"
              :loading="sendingRegister"
              :disabled="simulation.hasContract"
              @click="sendInfo(false)"
              name="updateAdditionalInformations"
            />
          </div>
        </BlockContent>
      </div>

      <div class="col-xl-6 col-lg-12">
        <div>
          <BlockContent title-t="simulation.document.title" title-level="4" e2e-block="simulationDocuments">
            <DocumentList
              id="simulation-demand"
              ref="documentList"
              style="max-width: 100%; overflow: auto; position: relative"
              :read-only="user.isReadOnly"
              context="Simulation"
              :context-id="simulationId"
              @document-uploaded="afterUpload"
            />
          </BlockContent>
          <BlockContent
            title-t="simulation.message.title"
            title-level="4"
            v-if="
              conf.messages &&
              (user.isBusinessMan ||
                user.isAdmin ||
                isTheme(['lbp', 'financia']) ||
                hasRole('ROLE_SALESMAN_EXT_PREMIUM_SHOW'))
            "
            e2e-block="simulationMessages"
          >
            <MessageList
              context="AppBundle\Entity\Simulation"
              :context-id="simulationId"
              :active="simulation.status"
              api-call
            />
          </BlockContent>
        </div>
      </div>
    </div>

    <div
      class="row mb-4"
      v-if="
        !user.isReadOnly &&
        !isAccepted &&
        !simulation.refused &&
        (user.isBusinessMan || user.isAdmin || isTheme(['lbp', 'financia', 'olinn']))
      "
    >
      <div class="col text-center p-2">
        <div class="alert alert-info col-md-6 mx-auto" v-if="simulation.status == 'VALIDATION_REQUEST'">
          {{ $t('simulation.status.VALIDATION_REQUEST.message') }}
        </div>
        <ButtonAll
          v-if="
            !(isLimited() && simulation.status == 'VALIDATION_REQUEST') &&
            simulation.status != 'CANCELED' &&
            simulation.company?.isAutoCall === false
          "
          type="validation"
          size="large"
          :label="
            isManuallyStudyable
              ? 'simulation.popin.study.button'
              : isLimited()
                ? 'simulation.sendValidation'
                : isRequestable
                  ? 'simulation.send'
                  : 'simulation.sendUpdate'
          "
          :loading="sendingDemand"
          @click="sendInfo(true)"
          e2e-button="sendDemand"
        />
      </div>
    </div>
    <div v-if="!isDeliveryAt" class="text-danger text-center">
      {{ $t('simulation.fields.deliveryAt.error') }}
    </div>
    <div v-if="errors.length > 0" class="text-danger text-center">
      <span v-for="error in errors">
        {{ $t('simulation.fields.' + error + '.required') }}
      </span>
    </div>
  </div>
  <div v-else class="row">
    <div class="col-md-12">
      <BlockContent>
        <div class="row d-flex">
          <div class="col col-md-4 flex-fill">
            <h4>{{ $t('contract.information.menu_params', { data: $t('contract.information.contributor') }) }}</h4>
            <div class="row py-3 mb-3 mx-3 loading"></div>
            <div class="row py-3 mb-3 mx-3 loading"></div>
            <div class="row py-3 mb-3 mx-3 loading"></div>
            <div class="row py-3 mb-3 mx-3 loading"></div>
          </div>
          <div class="col col-md-4 flex-fill border-information">
            <h4>{{ $t('contract.information.menu_params', { data: $t('contract.list.table.equipment') }) }}</h4>
            <div class="row py-3 mb-3 mx-3 loading"></div>
            <div class="row py-3 mb-3 mx-3 loading"></div>
            <div class="row py-3 mb-3 mx-3 loading"></div>
            <div class="row py-3 mb-3 mx-3 loading"></div>
          </div>
          <div class="col col-md-4 flex-fill">
            <h4>{{ $t('contract.information.menu_params', { data: $t('contract.information.prestation') }) }}</h4>
            <div class="row py-3 mb-3 mx-3 loading"></div>
            <div class="row py-3 mb-3 mx-3 loading"></div>
            <div class="row py-3 mb-3 mx-3 loading"></div>
            <div class="row py-3 mb-3 mx-3 loading"></div>
          </div>
        </div>
      </BlockContent>
    </div>
  </div>
</template>
